<template>
  <div>
    <gc-order-express-with-data @downloadExpressFile="handleDownloadExpressFile">
    </gc-order-express-with-data>
  </div>
</template>

<script>
import EMKT from '@/emkt.js'
import { downloadExpressOutFile } from '@/emktcommon/api/orderApi.js'
import GcOrderExpressWithData from '@/emktcommon/orders/express/GcOrderExpressWithData.vue'
// import $ from 'jquery'
export default {
  components: { GcOrderExpressWithData },
  props: {},
  data () {
    return {}
  },
  mounted () {
  },
  computed: {},
  methods: {
    handleDownloadExpressFile (contractNo) {
      console.log(contractNo, EMKT.isWapp)
      if (EMKT.isWapp) {
        EMKT.wxDownloadExpressSheet(contractNo)
      } else {
        downloadExpressOutFile(contractNo)
      }
    }
  }
}
</script>

<style scoped>
.pay-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 23px;
  color: #fff;
  text-align: center;
  font-size: 12px;
}

row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}


.return-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
}

</style>



// WEBPACK FOOTER //
// OrderExpressPage.vue?18442259